<template lang="html">
  <div class="box-email">
    <div class="text-xs-center info-hotsite">
      <h3 class="email-success">Agendamento realizado</h3>
      Seu pedido foi recebido. Muito obrigado por nos contratar.
    </div>
  </div>
</template>

<script>
export default {
  name: 'success'
}
</script>

<style lang="css">

.email-success{
  color: #009865
}
</style>



// WEBPACK FOOTER //
// Success.vue?f1aff2e0